import { setCustomIconsLoader } from '@iconify/vue'

export const iconSets = {
  mdi: () => import('@iconify-json/mdi/icons.json'),
  'fa-solid': () => import('@iconify-json/fa-solid/icons.json'),
  fa: () => import('@iconify-json/fa/icons.json'),
  ic: () => import('@iconify-json/ic/icons.json'),
  'material-symbols': () => import('@iconify-json/material-symbols/icons.json'),
  devicon: () => import('@iconify-json/devicon/icons.json'),
  'devicon-plain': () => import('@iconify-json/devicon-plain/icons.json'),
}

/**
 * Serves every icon set from a bundled chunk instead of the Iconify API.
 *
 * The API loader gives up after ~6s and the mounted icon then stays empty
 * even once the data arrives, so a slow network left icons blank.
 *
 * @returns {void}
 */
export function registerIconSets () {
  for (const [prefix, loadSet] of Object.entries(iconSets)) {
    setCustomIconsLoader(async () => (await loadSet()).default, prefix)
  }
}
